const CLICK_ATTRIBUTES = {
  id: "modules/analytics/schema/clickAttributes",
  type: "object",
  properties: {
    click_type: {
      type: "string",
    },
    click_text: {
      type: "string",
    },
    click_source: {
      type: "string",
    },
    link: {
      type: "string",
    },
    custom: {
      type: "object",
    },
  },
  required: ["click_type"],
}

export default CLICK_ATTRIBUTES
